<tt-page *ngIf="!!setting">
    <mgt-login #login></mgt-login>

    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="selectionCriterias"></ng-container>
        </tt-card>

        <ng-container *ngTemplateOutlet="gridLists"></ng-container>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="acreminderproposal_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="20">
                    <tt-card>
                        <ng-container *ngTemplateOutlet="selectionCriterias"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="80">
                    <ng-container *ngTemplateOutlet="gridLists"></ng-container>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #selectionCriterias>
    <ng-container *ngIf="!!setting">
        <tt-select ttLabel="businessco" [(ttModel)]="setting.businessco_no" [ttData]="selectListCompanies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>

        <tt-tabs ttRememberId="gb_acreminderproposal_main" [(ttSelectedId)]="setting.gb_acreminderproposal_main">
            <tt-tab ttId="ACCUSTTRANS" ttLabel="gb_acreminderproposal_main_accusttrans"></tt-tab>
            <tt-tab ttId="ACREMINDER" ttLabel="gb_acreminderproposal_main_acreminder"></tt-tab>
        </tt-tabs>
    </ng-container>
</ng-template>

<ng-template #gridLists>
    <ng-container *ngIf="!!setting">
        <tt-grid *ngIf="setting.gb_acreminderproposal_main === 'ACCUSTTRANS' && !!gridPosts" class="flex-1" [(ttOptions)]="gridPosts"></tt-grid>
        <tt-grid *ngIf="setting.gb_acreminderproposal_main === 'ACREMINDER' && !!gridReceivers" class="flex-1" [(ttOptions)]="gridReceivers"></tt-grid>
    </ng-container>
</ng-template>

<!--<tt-page class="col-xs-12 sp-0 height-full">
    <mgt-login></mgt-login>

    <tt-card class="col-xs-12 col-md-4 p-5">
        <tt-select class="col-xs-12 sp-0" tt-label="businessco" tt-model="vm.model.setting.businessco_no" tt-change="vm.onChanged($value, 'businessco_no')" tt-data="vm.model.selectListCompanies" tt-data-id="businessco_no" tt-data-name="company_name"></tt-select>
        <tt-button class="col-xs-12 sp-0" tt-text="acreminderproposal_create" tt-click="vm.updateChanges()" tt-spin="vm.model.updating" tt-text-align="center" tt-type="primary" tt-icon="fas fa-sync-alt" tt-icon-align="center"></tt-button>
        <tt-buttons-radio class="col-xs-12 sp-0" tt-buttons="vm.model.bgAcReminderProposalMain.buttons" tt-model="vm.model.bgAcReminderProposalMain.selected" tt-change="vm.selectBgAcReminderProposalMain($value)"></tt-buttons-radio>
    </tt-card>

    <tt-grid ng-if="vm.model.bgAcReminderProposalMain.selected === 'ACCUSTTRANS' && vm.model.gridPostsReady" class="col-xs-12 p-5 flex-1" tt-options="vm.gridPosts"></tt-grid>
    <tt-grid ng-if="vm.model.bgAcReminderProposalMain.selected === 'ACREMINDER' && vm.model.gridReceiversReady" class="col-xs-12 p-5 flex-1" tt-options="vm.gridReceivers"></tt-grid>
</tt-page>-->
